import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4a3f0991"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("head", null, [
  /*#__PURE__*/_createElementVNode("title", null, "Developer Yoseph"),
  /*#__PURE__*/_createElementVNode("meta", {
    name: "viewport",
    content: "width=device-width, initial-scale=1.0"
  }),
  /*#__PURE__*/_createElementVNode("meta", {
    property: "og:title",
    content: "Yoseph Alabdulwahab's Portfolio"
  }),
  /*#__PURE__*/_createElementVNode("meta", {
    property: "og:url",
    content: "https://www.yosephsa.com/"
  }),
  /*#__PURE__*/_createElementVNode("meta", {
    property: "og:type",
    content: "website"
  }),
  /*#__PURE__*/_createElementVNode("meta", {
    name: "twitter:card",
    content: "summary_large_image"
  }),
  /*#__PURE__*/_createElementVNode("link", {
    rel: "stylesheet",
    href: "https://fonts.googleapis.com/css?family=Fredericka+the+Great"
  }),
  /*#__PURE__*/_createElementVNode("link", {
    rel: "stylesheet",
    href: "https://fonts.googleapis.com/css?family=Parisienne"
  })
], -1))
const _hoisted_2 = { id: "page-content" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "page-title" }, [
  /*#__PURE__*/_createElementVNode("h1", null, "My Page")
], -1))
const _hoisted_4 = { id: "page-content-body" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NavBar = _resolveComponent("NavBar")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("body", null, [
      _createVNode(_component_NavBar),
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_router_view)
        ])
      ])
    ])
  ], 64))
}